import {gql, useMutation, MutationHookOptions} from '@apollo/client';
import {
  RegisterDeviceMutation,
  RegisterDeviceMutationVariables,
} from '../types/graphql';

/**
 * Mutation to register this web client with the server.
 */
export const REGISTER_DEVICE = gql`
  mutation RegisterDevice(
    $deviceId: ID!
    $token: String!
    $ownerId: ID!
    $deviceType: DeviceType!
  ) {
    registerDevice(
      input: {
        id: $deviceId
        ownerId: $ownerId
        type: $deviceType
        token: $token
      }
    ) {
      id
      owner {
        fullName
      }
    }
  }
`;

/**
 * Hook to register device.
 */
export const useRegisterDevice = (
  opts?: MutationHookOptions<
    RegisterDeviceMutation,
    RegisterDeviceMutationVariables
  >,
) =>
  useMutation<RegisterDeviceMutation, RegisterDeviceMutationVariables>(
    REGISTER_DEVICE,
    opts,
  );
